<template>
  <section class="aidrama-box5">
    <div class="aidrama-box5__inner">
      <header class="aidrama-box5__head">
        <h2 class="aidrama-box5__title">多元人群适配<br/>共赴AI漫剧新赛道</h2>
        <p class="aidrama-box5__sub">精准匹配不同人群，赋能漫剧技能成长</p>
      </header>

      <div class="aidrama-box5__rows">
        <div class="aidrama-box5__row">
          <article
            v-for="card in rowTop"
            :key="card.text"
            class="aidrama-box5-card"
            :class="`aidrama-box5-card--${card.tone}`"
          >
            <div class="aidrama-box5-card__avatar">
              <img :src="card.avatar" alt="" aria-hidden="true" />
            </div>
            <div class="aidrama-box5-card__panel">
              <p class="aidrama-box5-card__text">{{ card.text }}</p>
            </div>
          </article>
        </div>
        <div class="aidrama-box5__row aidrama-box5__row--bottom">
          <article
            v-for="card in rowBottom"
            :key="card.text"
            class="aidrama-box5-card"
            :class="`aidrama-box5-card--${card.tone}`"
          >
            <div class="aidrama-box5-card__avatar">
              <img :src="card.avatar" alt="" aria-hidden="true" />
            </div>
            <div class="aidrama-box5-card__panel">
              <p class="aidrama-box5-card__text" v-html="card.text"></p>
            </div>
          </article>
        </div>
      </div>

      <button type="button" class="aidrama-box5__cta" @click="handleCtaClick">
        <span class="aidrama-box5__cta-text">我适合学吗？</span>
        <img class="aidrama-box5__cta-arrow" :src="btnArrow" alt="" />
      </button>
    </div>
  </section>
</template>

<script>
export default {
  name: "AidramaBox5",
  data() {
    return {
      btnArrow: require("../../../assets/coursePage/aidrama/box5/btn_arrow.png"),
      rowTop: [
        {
          text: "大学生/应届生/零基础转行快速就业",
          tone: "blue",
          avatar: require("../../../assets/coursePage/aidrama/box5/avatar_1.png"),
        },
        {
          text: "短视频博主/编导升级AI能力",
          tone: "purple",
          avatar: require("../../../assets/coursePage/aidrama/box5/avatar_2.png"),
        },
        {
          text: "宝妈/自由职业在家接单变现",
          tone: "blue",
          avatar: require("../../../assets/coursePage/aidrama/box5/avatar_3.png"),
        },
      ],
      rowBottom: [
        {
          text: "设计/影视/动漫从业者技能升级",
          tone: "purple",
          avatar: require("../../../assets/coursePage/aidrama/box5/avatar_4.png"),
        },
        {
          text: "想做个人IP、网文漫改<br/>创业者",
          tone: "blue",
          avatar: require("../../../assets/coursePage/aidrama/box5/avatar_5.png"),
        },
      ],
    };
  },
  methods: {
    handleCtaClick() {
      qimoChatClick();
      if (window.zhuge) {
        window.zhuge.track("点击_传智AI漫剧页-第5屏-我适合学吗？", {
          终端: "H5",
          名称: "传智AI漫剧页-第5屏-我适合学吗？",
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">

.aidrama-box5 {
  position: relative;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  background: linear-gradient(265.00deg, rgba(215, 85, 255, 1) 0%,rgba(16, 82, 255, 1) 15.126%,rgba(9, 141, 255, 1) 72.119%,rgba(1, 151, 255, 1) 99.156%);
}

.aidrama-box5__bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top center;
  pointer-events: none;
}

.aidrama-box5__inner {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 88px 40px 80px;
  box-sizing: border-box;
}

/* 65:4045 gap 6px */
.aidrama-box5__head {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-width: 0;
}

.aidrama-box5__title {
  margin: 0;
  font-size: 48px;
  font-family: "Microsoft YaHei-Bold", "Microsoft YaHei", sans-serif;
  font-weight: 700;
  line-height: 60px;
  letter-spacing: 4px;
  text-align: center;
  color: #fff;
  white-space: nowrap;
}

.aidrama-box5__sub {
  margin: 0;
  font-size: 22px;
  font-family: "Microsoft YaHei-Regular", "Microsoft YaHei", sans-serif;
  font-weight: 400;
  line-height: 60px;
  letter-spacing: 4px;
  text-align: center;
  color: #fff;
}

.aidrama-box5__rows {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  width: 100%;
  margin-top: 40px;
}

.aidrama-box5__row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 12px;
  width: 100%;
}

.aidrama-box5__row--bottom {
  gap: 20px;
}

/* 65:4048 等 — 120×153 */
.aidrama-box5-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 240px;
  flex-shrink: 0;
}

.aidrama-box5-card__avatar {
  position: relative;
  z-index: 2;
  width: 140px;
  height: 140px;
  box-sizing: border-box;
  border: 12px solid rgba(92, 220, 255, 0.54);
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
}

.aidrama-box5-card__avatar img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 65:4049 — 120×140 @ top13；文案 top83 */
.aidrama-box5-card__panel {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  height: 280px;
  margin-top: -114px;
  padding: 140px 20px 24px;
  box-sizing: border-box;
  border-radius: 24px;
}

/* 65:4049 — SVG matrix(0,-1,1,0) 竖向：上淡下实，勿直抄 offset0→0% */
.aidrama-box5-card--blue .aidrama-box5-card__panel {
  background: linear-gradient(
    180deg,
    rgba(39, 181, 255, 0) 0%,
    rgba(39, 181, 255, 1) 100%
  );
}

.aidrama-box5-card--purple .aidrama-box5-card__panel {
  background: linear-gradient(
    180deg,
    rgba(191, 91, 255, 0) 0%,
    rgba(191, 91, 255, 1) 100%
  );
}

.aidrama-box5-card__text {
  margin: 0;
  width: 200px;
  font-size: 26px;
  font-family: "Microsoft YaHei-Bold", "Microsoft YaHei", sans-serif;
  font-weight: 700;
  line-height: 40px;
  letter-spacing: 4px;
  text-align: center;
  color: #fff;
}

/* 65:4068 */
.aidrama-box5__cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  margin-top: 44px;
  padding: 36px 60px 36px 72px;
  box-sizing: border-box;
  border: none;
  border-radius: 24px;
  box-shadow: inset 0 0 22px rgba(255, 255, 255, 1);
  background: linear-gradient(
    270deg,
    rgba(188, 117, 255, 1) 0%,
    rgba(117, 104, 255, 1) 100%
  );
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.aidrama-box5__cta-text {
  font-size: 30px;
  font-family: "Microsoft YaHei-Bold", "Microsoft YaHei", sans-serif;
  font-weight: 700;
  line-height: 30px;
  letter-spacing: 4px;
  color: #fff;
  white-space: nowrap;
}

.aidrama-box5__cta-arrow {
  display: block;
  width: 12px;
  height: 20px;
  flex-shrink: 0;
  object-fit: contain;
  opacity: 0.4;
}
</style>
